export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ReadyLoop logo"
      style={{ color: 'var(--rl-primary)' }}
    >
      <defs>
        <filter id="logo-glow">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="1.5" opacity="0.2" />
      <circle cx="24" cy="24" r="14" stroke="currentColor" strokeWidth="1.5" opacity="0.45" />
      <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      <circle cx="24" cy="24" r="3" fill="currentColor" filter="url(#logo-glow)" />
    </svg>
  );
}
